function formatFileSize(bytes: number): string {
  const power = 1000;
  const sizeLabels = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (bytes === null || isNaN(bytes)) return '0B';

  let n = 0;

  while (bytes >= power) {
    bytes /= power;
    n++;
  }

  const formattedSize = Number(bytes)
    .toFixed(2)
    .replace(/\.0+$|(?<=\.\d)0+$/, '');

  return `${formattedSize}${sizeLabels[n]}`;
}

export default formatFileSize;
